import { useCallback } from 'react';
import { useQuote } from '../context/QuoteContext';

/**
 * Canonical "advance to the next journey step" action, mirroring the wizard's
 * Next Step button: guard on canProceed, request a background save through the
 * quote's save lane, then advance. Shared by QuoteWizard (manual Next) and the
 * auto-advancing steps so the paths cannot diverge.
 */
export const useQuoteAdvance = () => {
    const quote = useQuote();

    return useCallback(() => {
        if (!quote.canProceed) return;
        if (quote.saveLane.canSave) {
            quote.saveLane.requestSave();
        }
        quote.nextStep();
    }, [quote]);
};
